import * as go from 'gojs/release/go-module';

import { HiddenCategory } from 'src/containers/ProjectDiagram/constants/categories';

type HiddenHistoryItem = {
  value: string | null;
  category: HiddenCategory;
};

export const defaultHiddenPartData = {
  value: null,
  category: HiddenCategory.NOT_HIDDEN,
  key: `${HiddenCategory.NOT_HIDDEN}-null`,
};

export class HiddenPart extends go.Part {
  private _hiddenHistory: HiddenHistoryItem[] = [];

  setValue({ value, category }: HiddenHistoryItem) {
    this.data.value = value;
    this.data.category = category;
    this.data.key = `${this.data.category}-${this.data.value}`;
    return this.data.key;
  }

  addHiddenHistory(
    hiddenPartIsSelected: boolean,
    appendSelectionHistory: boolean
  ) {
    if (!appendSelectionHistory) {
      this.clearHiddenHistory();
    }
    if (hiddenPartIsSelected) {
      this._hiddenHistory.push({
        value: this.data.value,
        category: this.data.category,
      });
    } else {
      this.setValue({ ...defaultHiddenPartData });
      this._hiddenHistory.push({
        value: null,
        category: HiddenCategory.NOT_HIDDEN,
      });
    }
  }

  clearHiddenHistory() {
    this._hiddenHistory = [];
  }

  setPreviousValue(previousIdx: number) {
    this.setValue(
      this._hiddenHistory[previousIdx] || { ...defaultHiddenPartData }
    );
    // Note: selectPreviousSelection re-adds the hiddenPart, so we
    // temporarily remove it from the list
    this._hiddenHistory.splice(previousIdx);
  }

  updateAttributeValue(
    prevValue: string,
    newValue: string
  ): Record<string, string> {
    const updatedKeys: Record<string, string> = {};

    if (
      this.data.value === prevValue &&
      this.data.category === HiddenCategory.MODEL_CONCEPT_ATTRIBUTE
    ) {
      updatedKeys[this.data.key] = this.setValue({
        value: newValue,
        category: this.data.category,
      });
    }

    this._hiddenHistory = this._hiddenHistory.map((history) => ({
      value:
        history.value === prevValue &&
        history.category === HiddenCategory.MODEL_CONCEPT_ATTRIBUTE
          ? newValue
          : history.value,
      category: history.category,
    }));

    return updatedKeys;
  }

  getPreviousValue(previousIdx: number | undefined) {
    return (
      (previousIdx !== undefined && this._hiddenHistory[previousIdx]?.value) ||
      null
    );
  }

  getHiddenHistoryLength() {
    return this._hiddenHistory.length;
  }
}
